<script xmlns:svelte="http://www.w3.org/1999/html">
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2025 (original work) Open Assessment Technologies SA ;

    // Core
    import { createEventDispatcher } from 'svelte';
    // Components
    import Flyout from '../flyout/Flyout.svelte';

    export let data = {};
    export let icon;
    export let isClickable = true;
    export let isFlyoutPopupVisible = false;
    export let actionName;

    const dispatch = createEventDispatcher();
    let referenceElement = null;
    let rootElement = null;
    const flyoutModifiers = [
        {
            name: 'setZIndex',
            enabled: true,
            phase: 'write',
            fn: ({ state: _state }) => {
                if (_state.elements.popper) {
                    _state.elements.popper.style.zIndex = 1000;
                }
            }
        }
    ];
    const handleCancel = () => {
        dispatch('cancel');
    };
</script>

<div bind:this={rootElement}>
    {#if isClickable}
        <div
            bind:this={referenceElement}
             tabindex="0"
             role="button"
             aria-pressed="false"
        >
            <slot name="link"/>
        </div>
        <Flyout
            on:hide={handleCancel}
            bind:isOpen={isFlyoutPopupVisible}
            reference={referenceElement}
            trigger="click"
            modifiers={flyoutModifiers}
        >
            <slot name="flyout-content" />
        </Flyout>
    {:else}
        <slot
            name="link"
            role="button"
            aria-pressed="false"
        />
    {/if}
</div>
